import moment from 'moment'
import langmap from 'langmap'
import i18next from 'i18next'
import { translations } from './translation'

const getCountryCodeFromLocale = (locale) => {
  const locArray = locale ? locale.split('_') : []
  return locArray.length > 1 ? locArray[1] : 'US'
}

const getLanguageCodeFromLocale = (locale) => (locale ? locale.split('_')[0] : 'en')

const usTerritories = ['PR', 'VI', 'GU', 'AS', 'MP']
const supportedCountries = ['IT', 'FR', 'US', 'GB', 'NL', 'FI', 'PT', 'ES', 'IE', 'DE', 'BE']

const isCountrySupported = (locale) => {
  const allSupportedCountries = supportedCountries.concat(usTerritories)
  return allSupportedCountries.includes(getCountryCodeFromLocale(locale))
}

const isUSTerritory = (country) => usTerritories.includes(country)

const getLongDateFormatFromLocale = (locale) => {
  const countryCode = getCountryCodeFromLocale(locale)
  return countryCode === 'US' || isUSTerritory(countryCode) || !countryCode || !isCountrySupported(locale) ? 'MMMM D, YYYY' : 'DD.MM.YYYY'
}

const getShortDateFormatFromLocale = (locale) => {
  const countryCode = getCountryCodeFromLocale(locale)
  return countryCode === 'US' || isUSTerritory(countryCode) || !countryCode || !isCountrySupported(locale) ? 'MM/DD/YYYY' : 'DD.MM.YYYY'
}

const isLanguageSupported = (locale) => {
  const supportedLanguages = Object.keys(translations)
  return supportedLanguages.includes(locale) || supportedLanguages.includes(getLanguageCodeFromLocale(locale))
}

const getSupportedLanguages = () => (Object.keys(translations))

const getSupportedLanguageCode = (locale) => {
  // this returns either the language or the locale  of a supported language (i.e. 'de' or 'en_IE')
  const supportedLanguages = getSupportedLanguages()
  if (supportedLanguages.includes(locale)) {
    return locale
  }
  if (supportedLanguages.includes(getLanguageCodeFromLocale(locale))) {
    return getLanguageCodeFromLocale(locale)
  }
    return 'en'
}

const getAvailableLanguages = () => {
  const availableMap = {}
  getSupportedLanguages().forEach((language) => {
    const dashedLocale = language.replace('_', '-')
    if (langmap[dashedLocale]) {
      availableMap[language] = langmap[dashedLocale].nativeName
    }
  })
  const sortedAvailableKeys = Object.keys(availableMap).sort((a, b) => availableMap[a].localeCompare(availableMap[b]))
  const sortedMap = {}
  sortedAvailableKeys.forEach((locale) => { sortedMap[locale] = availableMap[locale] })
  return sortedMap
}

const getLocaleToUseForDateFormatting = (locale) => {
  if (!getCountryCodeFromLocale(locale)) {
    return 'en_US'
  } if (isLanguageSupported(locale)) {
    if (locale.split('_').length === 1) {
      return `${locale}_US`
    }
    return locale
  } if (getCountryCodeFromLocale(locale) === 'US') {
    return 'en_US'
  }
  return 'en_GB'
}

const getLocaleFromSelectedLanguageAndLocale = (selectedLanguage, locale) => {
  if (!selectedLanguage) {
    return locale
  }
  if (selectedLanguage.split('_').length === 2) {
    return selectedLanguage
  }
  if (selectedLanguage.split('_').length === 1) {
    return `${selectedLanguage}_${getCountryCodeFromLocale(locale)}`
  }
  return locale
}

const missedNextFollowUp = (nextScheduledFollowUp) => (nextScheduledFollowUp ? moment(nextScheduledFollowUp, 'YYYY-MM-DD').isBefore(moment().startOf('day')) : null)

const checkHyphenation = (text) => {
  if (text && text.includes('-')) {
    return text.replace('-', '-\u200B')
  }
  return text
}

function log(msg) {
  if (window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage(`log;${msg}`)
  } else {
    // eslint-disable-next-line no-console
    console.log(msg)
  }
}

const getOnboardingButtonTextSize = () => (getLanguageCodeFromLocale(i18next.language) === 'de' ? 1 : 1.4)

export {
  checkHyphenation,
  getLongDateFormatFromLocale, getShortDateFormatFromLocale,
  getCountryCodeFromLocale, getLanguageCodeFromLocale, getOnboardingButtonTextSize, isCountrySupported,
  getLocaleToUseForDateFormatting, missedNextFollowUp, isUSTerritory, getSupportedLanguages, log,
  isLanguageSupported, getSupportedLanguageCode, getAvailableLanguages, getLocaleFromSelectedLanguageAndLocale,
}
